import { createServerFn } from "@tanstack/react-start";

const MAX_MESSAGES = 20;
const MAX_CHARS_PER_MESSAGE = 4000;
const MAX_TOTAL_CHARS = 20000;

export const askMeiAi = createServerFn({ method: "POST" })
  .inputValidator((data: { messages: { role: "user" | "assistant"; content: string }[] }) => {
    if (!data || !Array.isArray(data.messages)) {
      throw new Error("Formato inválido: messages deve ser uma lista.");
    }
    if (data.messages.length === 0) {
      throw new Error("Envie ao menos uma mensagem.");
    }
    if (data.messages.length > MAX_MESSAGES) {
      throw new Error(`Limite de ${MAX_MESSAGES} mensagens por chamada excedido.`);
    }
    let total = 0;
    const sanitized = data.messages.map((m) => {
      if (!m || (m.role !== "user" && m.role !== "assistant")) {
        throw new Error("Mensagem com role inválido.");
      }
      if (typeof m.content !== "string") {
        throw new Error("Conteúdo de mensagem inválido.");
      }
      const content = m.content.trim();
      if (content.length === 0) {
        throw new Error("Mensagem vazia não é permitida.");
      }
      if (content.length > MAX_CHARS_PER_MESSAGE) {
        throw new Error(`Mensagem excede ${MAX_CHARS_PER_MESSAGE} caracteres.`);
      }
      total += content.length;
      return { role: m.role, content };
    });
    if (total > MAX_TOTAL_CHARS) {
      throw new Error(`Conversa excede ${MAX_TOTAL_CHARS} caracteres no total.`);
    }
    return { messages: sanitized };
  })
  .handler(async ({ data }) => {
    const apiKey = process.env.LOVABLE_API_KEY;
    if (!apiKey) throw new Error("LOVABLE_API_KEY não configurada");

    const systemPrompt = `Você é um assistente especialista em MEI (Microempreendedor Individual) no Brasil.
Responda dúvidas sobre: DAS, DASN-SIMEI, limite de faturamento (R$ 81.000), enquadramento, ocupações permitidas, emissão de nota fiscal, contratação de funcionário, baixa do CNPJ, e regras do Simples Nacional.
Seja claro, objetivo e cite valores e prazos atualizados quando relevante. Se a pergunta fugir do escopo MEI/contábil/fiscal, redirecione gentilmente.
Responda sempre em português do Brasil.`;

    const response = await fetch("https://ai.gateway.lovable.dev/v1/chat/completions", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "google/gemini-2.5-flash",
        messages: [{ role: "system", content: systemPrompt }, ...data.messages],
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      console.error("AI Gateway error:", response.status, text);
      throw new Error(`AI Gateway: ${response.status}`);
    }

    const json = await response.json();
    return { content: json.choices[0].message.content as string };
  });
